/** @format */

import { combineReducers } from "@reduxjs/toolkit";
import setting from "./reducers";

const reducer = setting;
export * from "./reducers";
export default reducer;
